import Collaboration from "../components/Collaboration";
import ListChild from "../components/ListChild";
import PageTitle from "../components/PageTitle";
import ShopFilter from "../components/ShopFilter";

function ShopList(props) {
  return (
    <>
      <PageTitle title="Shop list Default" path={["Pages ", "Shop List"]} />
      <ShopFilter />
      <div className="max-w-5xl mx-auto ">
        <ListChild img={require("../assets/shop-list/img01.png")} />
        <ListChild img={require("../assets/shop-list/img02.png")} />
        <ListChild img={require("../assets/shop-list/img03.png")} />
        <ListChild img={require("../assets/shop-list/img04.png")} />
      </div>
      <Collaboration />
    </>
  );
}

export default ShopList;
